const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const emptyHTMLString = "<p>&nbsp;</p>";

export const validateCafeDetailsForm = (data) => {
  const errors = {};
  if (!data.cafeAddress?.trim()) {
    errors.cafeAddress = "Cafe address is required.";
  }
  if (!data.cafeEmail?.trim()) {
    errors.cafeEmail = "Cafe email is required.";
  } else if (!emailRegex.test(data.cafeEmail)) {
    errors.cafeEmail = "Cafe email is invalid.";
  }
  if (!data.cafeContactNum?.trim()) {
    errors.cafeContactNum = "Cafe contact number is required.";
  }
  if (!data.operationStartTime?.trim()) {
    errors.operationStartTime = "Operation start time is required.";
  }
  if (!data.operationEndTime?.trim()) {
    errors.operationEndTime = "Operation end time is required.";
  }
  if (!data.copyrightLabel?.trim()) {
    errors.copyrightLabel = "Copyright label is required.";
  }
  if (!data.poweredByLabel?.trim()) {
    errors.poweredByLabel = "Powered by label is required.";
  }
  if (!data.privacyPolicy?.trim() || data.privacyPolicy === emptyHTMLString) {
    errors.privacyPolicy = "Privacy policy is required.";
  }
  if (
    !data.termsAndConditions?.trim() ||
    data.termsAndConditions === emptyHTMLString
  ) {
    errors.termsAndConditions = "Terms and conditions is required.";
  }
  if (!data.cafeLogo) {
    errors.cafeLogo = "Cafe logo is required.";
  }
  return errors;
};

export const validateCollaborationDetailsForm = (data) => {
  const errors = {};
  if (!data.existingCollaboration?.trim()) {
    errors.existingCollaboration = "Existing collaboration is required.";
  }
  return errors;
};

export const validateWebDetailsForm = (data) => {
  const errors = {};
  if (!data.siteMaintenance?.trim()) {
    errors.siteMaintenance = "Site maintenance is required.";
  }
  if (!data.browserTitle?.trim()) {
    errors.browserTitle = "Browser title is required.";
  }
  if (!data.metaDescription?.trim()) {
    errors.metaDescription = "Meta description is required.";
  }
  if (!data.metaKeywords?.trim()) {
    errors.metaKeywords = "Meta keywords is required.";
  }
  if (!data.oGTitle?.trim()) {
    errors.oGTitle = "Open graph title is required.";
  }
  if (!data.oGDescription?.trim()) {
    errors.oGDescription = "Open graph description is required.";
  }
  if (!data.oGURL?.trim()) {
    errors.oGURL = "Open graph URL is required.";
  }
  if (!data.oGType?.trim()) {
    errors.oGType = "Open graph type is required.";
  }
  return errors;
};
